module.exports = __webpack_public_path__ + "img/6.b11e0e9b.png";